import React, { useEffect, useState } from "react";
import { supabase } from "./supabaseClient";
import { v4 as uuidv4 } from "uuid";

// Get or create device ID
const getDeviceId = () => {
  let deviceId = localStorage.getItem("deviceId");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("deviceId", deviceId);
  }
  return deviceId;
};

function App() {
  const [barbers, setBarbers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingAction, setLoadingAction] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [rewardMessage, setRewardMessage] = useState("");
  const [currentVisits, setCurrentVisits] = useState(0);

  const deviceId = getDeviceId();

  // Fetch barbers and initial loyalty visits
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: barberData } = await supabase.from("barbers").select("*");
        if (barberData) setBarbers(barberData);

        const { data: loyaltyData } = await supabase
          .from("loyalty")
          .select("visits")
          .eq("device_id", deviceId)
          .maybeSingle();

        if (loyaltyData && loyaltyData.visits != null) {
          setCurrentVisits(loyaltyData.visits);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [deviceId]);

  const chooseService = async (barberOrService) => {
    if (loadingAction) return;
    setLoadingAction(true);

    let barberId = null;
    let serviceName = barberOrService;

    const barber = barbers.find((b) => b.name === barberOrService);
    if (barber) {
      barberId = barber.id;
      serviceName = barber.name;
    }

    try {
      // Insert service
      const { error: serviceError } = await supabase.from("services").insert([
        {
          barber_id: barberId,
          service_name: serviceName,
          device_id: deviceId,
        },
      ]);
      if (serviceError) throw serviceError;

      // Fetch current visits
      const { data: loyaltyData } = await supabase
        .from("loyalty")
        .select("visits")
        .eq("device_id", deviceId)
        .maybeSingle();

      let newVisits = loyaltyData?.visits ? loyaltyData.visits + 1 : 1;
      let newRewardMessage = "";

      if (newVisits === 5) {
        newRewardMessage = "🎉 You’re rewarded: Additional treatment on your next visit!";
        newVisits = 0;
      } else if (newVisits === 10) {
        newRewardMessage = "🥳 Congratulations! You earned a FREE haircut on your next visit!";
        newVisits = 0;
      }

      // Upsert loyalty record
      const { error: upsertError } = await supabase.from("loyalty").upsert(
        {
          device_id: deviceId,
          visits: newVisits,
          last_visit: new Date(),
        },
        { onConflict: ["device_id"] } // ⚡ THIS IS KEY
      );

      if (upsertError) throw upsertError;

      // Fetch updated visits
      const { data: updatedLoyalty } = await supabase
        .from("loyalty")
        .select("visits")
        .eq("device_id", deviceId)
        .maybeSingle();
      setCurrentVisits(updatedLoyalty?.visits || newVisits);

      setRewardMessage(newRewardMessage || `Visit recorded. Total visits: ${newVisits}`);
      setSubmitted(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingAction(false);
    }
  };

  if (loading)
    return <h2 style={{ textAlign: "center", marginTop: "20px" }}>Loading...</h2>;

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h1>Select Your Barber or Service</h1>

      {!submitted && (
        <>
          {barbers.map((b) => (
            <button
              key={b.id}
              onClick={() => chooseService(b.name)}
              disabled={loadingAction}
              style={{
                padding: "15px 25px",
                margin: "10px",
                fontSize: "18px",
                borderRadius: "8px",
                cursor: loadingAction ? "not-allowed" : "pointer",
              }}
            >
              {b.name}
            </button>
          ))}

          <button
            onClick={() => chooseService("Additional Service")}
            disabled={loadingAction}
            style={{
              padding: "15px 25px",
              margin: "10px",
              fontSize: "18px",
              borderRadius: "8px",
              cursor: loadingAction ? "not-allowed" : "pointer",
              backgroundColor: "#f0a500",
              color: "white",
              border: "none",
            }}
          >
            Additional Service
          </button>
        </>
      )}

      {submitted && (
        <div style={{ marginTop: "20px" }}>
          <h2>{rewardMessage}</h2>
        </div>
      )}

      {/* Debug panel */}
      {/* <div
        style={{
          marginTop: "30px",
          padding: "10px",
          border: "1px solid gray",
          borderRadius: "8px",
          display: "inline-block",
          textAlign: "left",
          fontSize: "14px",
          color: "#333",
        }}
      >
        <strong>DEBUG INFO</strong>
        <p>Device ID: {deviceId}</p>
        <p>Current Visits: {currentVisits}</p>
      </div> */}
    </div>
  );
}

export default App;
